import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "VehicleVersionListPage" */
	'pages/vehicle/VehicleVersion/VehicleVersionListPage'));

export default [{ component, exact: true, path: '/vehicle_versions' }];